import React, { Component } from 'react';
import _ from 'lodash';

import SimpleModal from '../SimpleModal';
import SiteSettingStore from '../../stores/SiteSettingStore';

export default class UploadSeal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      open: this.props.open,
      file: this.props.seal,
      preview_url: '',
      error_message: ''
    }

    this.onChange = this.onChange.bind(this);
    this.uploadSeal = this.uploadSeal.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.open !== nextProps.open){
      this.setState({open: nextProps.open});
    }
  }

  onChange(event){
    var reader = new FileReader();
    var file = event.target.files[0];
    if (file.size === 0) { return }

    reader.onloadend = () => {
      this.setState({
        file: file,
        preview_url: reader.result
      });
    }
    reader.readAsDataURL(file);
    event.target.value = '';
  }

  uploadSeal(){
    var self = this;
    if (this.state.file === undefined || this.state.file === null) { return }
    var data = new FormData();
    data.append('site_setting[seal]', this.state.file);

    SiteSettingStore.request({
      method: 'put',
      data: data,
    }).then(()=>{
      this.setState({open: false}, this.props.reloadData());
    }, function(error){
      let error_message = _.get(error.response.data, 'error.message', '');
      self.setState({error_message: error_message});
    });
  }

  onClose(){
    this.setState({open: false}, this.props.onClose());
  }

  render(){
    return (
      <SimpleModal 
        isOpen={this.state.open}
        title={'อัพโหลดตราประทับ'}
        showSubmitButton={false}
        onClose={this.onClose}>
        <div className='row mb-3'>
          {this.state.error_message && (
            <div className='col-12 text-danger'>
              {this.state.error_message}
            </div>
          )}

          {(!_.isEmpty(this.props.seal) && _.isEmpty(this.state.preview_url)) && (
            <div className='col-8 ml-auto mr-auto text-center'>
              <img alt="FILE" src={this.props.seal} style={{maxWidth: '100%'}} />
            </div>
          )}

          {!_.isEmpty(this.state.preview_url) && (
            <div className='col-8 ml-auto mr-auto text-center'>
              <img alt='FILE' src={this.state.preview_url} style={{maxWidth: '100%'}} />
            </div>
          )}
        </div>
        <div className='row mb-2'>
          <div className='col-12'>
            <input type='file' name='file' onChange={this.onChange} />
          </div>
        </div>
        <div className='row mb-3'>
          <div className='col-12 text-danger'>
            <small>ขนาดแนะนำคือ 259px x 259px (ไฟล์ .png)</small>
          </div>
        </div>
        <div className="modal-footer row">
          <button type='submit' className="btn btn-primary pointer" onClick={this.uploadSeal}>บันทึก</button>
          <button type='button' className="btn btn-secondary pointer" onClick={this.onClose}>ยกเลิก</button>
        </div>
      </SimpleModal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/settings/UploadSeal.js